import React from 'react';
import { Typography, Box } from '@mui/material';
import { useI18nContext } from '@procore/core-react';
import { iterableProvidedServices } from '../../data/filters/provided-services';
import NoStyleLink from '../ButtonsLinks/NoStyleLink';
import routes from '../../helpers/routes';
import { CityStateCountry } from '../../services/geo-info';
import { useStyles } from './BrowseByTrade.styles';
import TradeTitle, { TradesTitleProps } from './BrowseByTradeTitle';
import TradeCard, { TradeCardOverrideType } from './BrowseByTradeCard';
import { SeoListType } from '../../types/seo-list-type';

export const ViewMore: React.FC = () => {
  const I18n = useI18nContext();
  const classes = useStyles();

  return (
    <Box className={classes.viewMore} data-test-id="view-more">
      <NoStyleLink
        data-track-click="View More Card, Navigation, View More"
        href={routes.trades()}
      >
        <Typography variant="h3">
          {I18n.t('components.browse_by_trade.view_more')}
        </Typography>
      </NoStyleLink>
    </Box>
  );
};

const BrowseByTrade: React.FC<{
  location?: CityStateCountry;
  title?: TradesTitleProps;
  shouldViewMore?: boolean;
  TradeCardOverride?: TradeCardOverrideType;
  makeTradeUrl?: (trade: SeoListType) => string;
}> = ({
  location,
  title,
  shouldViewMore = true,
  TradeCardOverride,
  makeTradeUrl = routes.trades,
}) => {
  const classes = useStyles();

  let tradeNameComponent;
  tradeNameComponent = 'h3';
  if (title) {
    if (/h[1-9]/.test(title.component.toString())) {
      const headerLevel = parseInt(title.component.toString()[1], 10) + 1;
      tradeNameComponent = `h${headerLevel}`;
    } else {
      tradeNameComponent = title.variant;
    }
  }

  return (
    <Box>
      <Box mb={4}>
        <TradeTitle title={title} location={location} />
      </Box>
      <Box className={classes.tradeGrid} component="section">
        {iterableProvidedServices
          .filter((trade) => trade.icon)
          .map((trade) => (
            <Box component="section" key={trade.name}>
              <TradeCard
                name={trade.name}
                nameComponent={tradeNameComponent}
                icon={trade.icon}
                url={makeTradeUrl(
                  trade,
                  location?.country,
                  location?.state,
                  location?.city
                )}
                TradeCardOverride={TradeCardOverride}
              />
            </Box>
          ))}
      </Box>
      {shouldViewMore && <ViewMore />}
    </Box>
  );
};
export default BrowseByTrade;
